import { Button, Modal } from '@indipia/ui-core'
import { ORDER_MESSAGE } from '../../constants/materialOrder.logic'

// 발주정보 저장 충돌(409 ORDER_CONTENT_CONFLICT) 대화상자 — 최신 내용으로 바꾸기 / 내 입력으로 저장.
// 닫기는 대화상자만 닫고 저장 실패 상태를 유지한다(최신 내용으로 바꾸기와 다름).

interface Props {
  open: boolean
  busy?: boolean
  onTakeLatest: () => void
  onKeepMine: () => void
  onClose: () => void
}

export function OrderConflictModal({ open, busy = false, onTakeLatest, onKeepMine, onClose }: Props) {
  return (
    <Modal
      open={open}
      onClose={() => { if (!busy) onClose() }}
      title={ORDER_MESSAGE.conflictTitle}
      size="sm"
      footerAlign="stretch"
      footer={<>
        <Button variant="etc" disabled={busy} onClick={onClose}>{ORDER_MESSAGE.popup.close}</Button>
        <Button variant="secondary" disabled={busy} onClick={onTakeLatest}>
          {ORDER_MESSAGE.conflictTakeLatest}
        </Button>
        <Button variant="primary" loading={busy} onClick={onKeepMine}>
          {ORDER_MESSAGE.conflictKeepMine}
        </Button>
      </>}
    >
      <p className="text-body-sm text-text-primary">{ORDER_MESSAGE.conflictBody}</p>
    </Modal>
  )
}
